var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", [
      _vm._v("\n        - Sale Ends In: \n        "),
      _vm.isStarted && !_vm.isEnded
        ? _c("span", [
            _c("span", [_vm._v(_vm._s(_vm.formattedDays))]),
            _c("span", [_vm._v("d")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.formattedHours))]),
            _c("span", [_vm._v("h")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.formattedMinutes))]),
            _c("span", [_vm._v("m")]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden" }, [
              _vm._v(_vm._s(_vm.formattedSeconds)),
            ]),
          ])
        : !_vm.isStarted
        ? _c("span", [_vm._v("Coming Soon")])
        : _c("span", [_vm._v("00:00:00:00")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }